import React, { useEffect, useState } from "react";
import "./KnowledgeBaseManager.css";

const API_BASE_URL = "https://internal-api.profitwheel.com/api";

function KnowledgeBaseManager() {
  const [files, setFiles] = useState([]);
  const [showManager, setShowManager] = useState(false);
  const [file, setFile] = useState(null);
  const [status, setStatus] = useState("");

  const fetchFiles = () => {
    fetch(`${API_BASE_URL}/knowledge_base/files`)
      .then((res) => res.json())
      .then((data) => setFiles(data.files || []))
      .catch((err) =>
        console.error("Error fetching knowledge base files:", err)
      );
  };

  useEffect(() => {
    if (showManager) {
      fetchFiles();
    }
  }, [showManager]);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!file) return;

    console.log("Uploading file:", file.name, "Size:", file.size, "Type:", file.type);
    setStatus("Uploading...");

    const formData = new FormData();
    formData.append("file", file);

    // Log FormData contents
    for (let [key, value] of formData.entries()) {
      console.log("FormData entry:", key, value);
    }

    // Upload the document to the correct API endpoint
    fetch(`${API_BASE_URL}/knowledge_base/upload`, {
      method: "POST",
      body: formData,
      credentials: "include",
    })
      .then((res) => {
        console.log("Upload response status:", res.status);
        console.log("Upload response statusText:", res.statusText);
        console.log("Upload response ok:", res.ok);
        
        if (!res.ok) {
          return res.text().then(text => {
            console.log("Error response body:", text);
            throw new Error(`HTTP ${res.status}: ${res.statusText} - ${text}`);
          });
        }
        return res.json();
      })
      .then((data) => {
        console.log("Upload response data:", data);
        setStatus(data.message || data.error || "Upload successful");
        fetchFiles();
        setFile(null);
        e.target.reset();
      })
      .catch((err) => {
        console.error("Error uploading knowledge base file:", err);
        setStatus(`Error uploading file: ${err.message}`);
      });
  };

  const handleDelete = (filename) => {
    setStatus(`Deleting ${filename}...`);
    fetch(`${API_BASE_URL}/knowledge_base/files/${filename}`, {
      method: "DELETE",
    })
      .then((res) => {
        if (!res.ok) {
          return res.json().then(err => {
            throw new Error(err.error || "Failed to delete file");
          });
        }
        return res.json();
      })
      .then((data) => {
        setStatus(data.message);
        fetchFiles();
      })
      .catch((err) => {
        console.error("Error deleting file:", err);
        setStatus(`Error: ${err.message}`);
      });
  };

  return (
    <div className="kb-manager">
      <button
        className="toggle-button"
        onClick={() => setShowManager(!showManager)}
      >
        {showManager ? "Close KB Manager" : "Knowledge Base"}
      </button>
      {showManager && (
        <div className="kb-panel">
          <h2>Knowledge Base Files</h2>
          <ul className="file-list">
            {files.map((f) => (
              <li key={f}>
                <span>{f}</span>
                <button onClick={() => handleDelete(f)} className="delete-button">
                  Delete
                </button>
              </li>
            ))}
          </ul>
          <form className="upload-form" onSubmit={handleSubmit}>
            <input
              type="file"
              accept=".doc,.docx,.pptx,.pdf"
              onChange={(e) => setFile(e.target.files[0])}
            />
            <button type="submit" disabled={!file}>Upload</button>
          </form>
          {status && <p className="status-message">{status}</p>}
        </div>
      )}
    </div>
  );
}

export default KnowledgeBaseManager;
